export default __webpack_public_path__ + "static/media/onspring-logo.760637fe.svg";